import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronRightIcon } from "lucide-react";
import type { FC, ReactNode } from "react";

type Props = {
	icon: ReactNode;
	title: ReactNode;
	badge?: ReactNode;
	subtitle: ReactNode;
	right: ReactNode;
	onClick: () => void;
};

export const PortfolioRow: FC<Props> = ({
	icon,
	title,
	badge,
	subtitle,
	right,
	onClick,
}) => {
	const theme = useTheme();
	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={theme.spacingTokens.md}
			onClick={onClick}
			px={theme.spacingTokens.lg}
			py={1.4}
			sx={{
				cursor: "pointer",
				"&:active": { bgcolor: theme.palette.grey[100] },
			}}
		>
			{icon}
			<Stack flex={1} minWidth={0} gap={theme.spacingTokens.xs}>
				<Stack minWidth={0}>
					{title}
					<Typography variant="caption" color={theme.palette.grey[500]} noWrap>
						{subtitle}
					</Typography>
				</Stack>
				{badge && <Stack alignItems="flex-start">{badge}</Stack>}
			</Stack>
			<Stack alignItems="flex-end" flexShrink={0}>
				{right}
			</Stack>
			<ChevronRightIcon
				size={theme.iconSize.sm}
				color={theme.palette.grey[400]}
			/>
		</Stack>
	);
};
